import React, { useContext } from 'react';
import { ThemeContext } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import { useRouter } from 'next/router';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { invoicesForMonth, transactionsForMonth } from '../../utils/chart-data';
import { formatCurrency } from '../../utils/numbers';
import ChartTooltip from './ChartTooltip';

// Sales beside payments by month. `scope` narrows the linked lists, to one customer for example.
const PairedBars = ({ rows, currency, height = 190, scope = '' }) => {
    const theme = useContext(ThemeContext);
    const router = useRouter();
    const color = (name) => normalizeColor(name, theme);

    const renderTooltip = ({ active, payload }) => {
        const row = payload?.[0]?.payload;
        if (!active || !row || !(row.sales_amount || row.payment_amount)) return null;
        return (
            <ChartTooltip
                title={row.month}
                lines={[
                    `Sales ${formatCurrency(row.sales_amount, currency)}`,
                    `Payments ${formatCurrency(row.payment_amount, currency)}`,
                ]}
            />
        );
    };

    return (
        <ResponsiveContainer width="100%" height={height}>
            <BarChart data={rows} barGap={2} barCategoryGap="30%" margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
                <XAxis
                    dataKey="display_month_string"
                    interval={rows.length > 6 ? 'preserveStartEnd' : 0}
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 16, fill: color('text-weak') }}
                />
                <YAxis hide />
                <Tooltip cursor={false} isAnimationActive={false} content={renderTooltip} />
                <Bar
                    dataKey="sales_amount"
                    fill={color('chart-muted')}
                    radius={[4, 4, 0, 0]}
                    maxBarSize={18}
                    minPointSize={3}
                    isAnimationActive={false}
                    style={{ cursor: 'pointer' }}
                    onClick={(row) => router.push(`${invoicesForMonth(row.month)}${scope}`)}
                />
                <Bar
                    dataKey="payment_amount"
                    radius={[4, 4, 0, 0]}
                    maxBarSize={18}
                    minPointSize={3}
                    isAnimationActive={false}
                    style={{ cursor: 'pointer' }}
                    onClick={(row) => router.push(`${transactionsForMonth(row.month)}${scope}`)}
                >
                    {rows.map((row) => (
                        <Cell key={row.month} fill={color(row.payment_amount > 0 ? 'barchart-primary' : 'chart-muted')} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default PairedBars;
